export default "assets/secure-ff6751a4.svg";